module.exports = __webpack_public_path__ + "static/img/yytx40.c930d52.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx40.png
// module id = 818
// module chunks = 0